import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyPaginatorIntl as MatPaginatorIntl,MatLegacyPaginatorModule as MatPaginatorModule } from "@angular/material/legacy-paginator";
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { RouterLink } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TableVirtualScrollModule } from 'ng-table-virtual-scroll';
import { SimplebarAngularModule } from 'simplebar-angular';
import { BurgerButtonWrapperComponent } from '../burger-button-wrapper/burger-button-wrapper.component';
import { NewDocumentViewMenu } from '../components/templates/new-document-view/new-document-view.module';
import { DaveDoubleIconModule } from '../dave-double-icon/dave-double-icon.module';
import { DaveLoadingModule } from '../dave-loading/dave-loading.module';
import { AppButtonModule } from '../dave-utils-module/app-button-module/app-button.module';
import { AppFilterModule } from '../dave-utils-module/app-filter-module/app-filter.module';
import { DaveSharedComponentsModule } from '../dave-utils-module/dave-shared-components-module/dave-shared-components.module';
import { PipesModule } from '../dave-utils-module/dave-shared-components-module/pipes/pipes.module';
import { SelectSearchModule } from '../dave-utils-module/select-search/select-search.module';
import { GermanPaginatorIntl } from "../services/german-paginator-intl.service";
import { DynamicFolderNodeComponent } from './components/dynamic-folder-node/dynamic-folder-node.component';
import { EditFolderUserComponent } from './components/edit-folder-user/edit-folder-user.component';
import { FileExplorerComponent } from './components/file-explorer/file-explorer.component';
import { NewFolderDialogComponent } from './components/new-folder-dialog/new-folder-dialog.component';
import { SelectFolderDialogComponent } from './components/select-folder-dialog/select-folder-dialog.component';
import { SelectFolderComponent } from './components/select-folder/select-folder.component';
import { ViewFolderComponent } from './components/view-folder/view-folder.component';

@NgModule({
    declarations: [FileExplorerComponent, NewFolderDialogComponent, SelectFolderDialogComponent, ViewFolderComponent, EditFolderUserComponent],
    imports: [
        CommonModule,
        MatSidenavModule,
        AppButtonModule,
        FontAwesomeModule,
        MatTreeModule,
        MatIconModule,
        MatButtonModule,
        SimplebarAngularModule,
        MatTooltipModule,
        MatTableModule,
        MatSortModule,
        MatCheckboxModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatInputModule,
        MatCardModule,
        MatDividerModule,
        DaveSharedComponentsModule,
        MatDialogModule,
        MatMenuModule,
        ScrollingModule,
        TableVirtualScrollModule,
        PipesModule,
        DaveDoubleIconModule,
        MatTabsModule,
        SelectSearchModule,
        MatSelectModule,
        DaveLoadingModule,
        AppFilterModule,
        MatProgressBarModule,
        BurgerButtonWrapperComponent,
        RouterLink,
        MatExpansionModule,
        SelectFolderComponent,
        NewDocumentViewMenu,
        MatPaginatorModule,
        DynamicFolderNodeComponent,
    ],
    exports: [FileExplorerComponent],
    providers: [{ provide: MatPaginatorIntl, useClass: GermanPaginatorIntl }],
})
export class DaveFileExplorerModule {}
